import songsData from '../../data/data-songs.json';

const swiperWrapper = document.getElementById('swiper-wrapper-albums');
const trackList = document.getElementById('album-tracklist');
const trackListMobile = document.getElementById('album-tracklist-mobile');

const albumPreviewImg = document.getElementById('album-preview');
const albumPreviewWrapper = document.getElementById('album-preview-wrapper');
const albumPreviewTitle = document.getElementById('album-preview-title');
const albumPreviewTitleMobile = document.getElementById(
	'album-preview-title-mobile',
);
function setAndRenderAlbumsSlides() {
	songsData.albums[0].songs.forEach((song, index) => {
		const track = document.createElement('li');
		if (index === 0) track.classList.add('active-song');
		track.classList.add('albums__item-song');
		track.innerText = song.title;
		trackList.appendChild(track.cloneNode('true'));
		trackListMobile.appendChild(track);
	});

	// мало альбомов => x3
	function setData() {
		songsData.albums.forEach((album) => {
			const swiperSlide = document.createElement('div');
			const swiperSlideImg = document.createElement('img');
			swiperSlide.dataset.songsList = JSON.stringify(album.songs);
			swiperSlide.dataset.albumId = JSON.stringify(album.id);
			swiperSlide.dataset.albumTitle = JSON.stringify(album.title);
			swiperSlideImg.classList.add('albums__list-item-img');
			swiperSlideImg.src = '../../img/albums/' + album.image;
			swiperSlide.classList.add('swiper-slide');
			swiperSlide.appendChild(swiperSlideImg);
			swiperWrapper.appendChild(swiperSlide);
		});
	}
	setData();
	setData();
	setData();
	setData();

}

function setAndRenderPreviewAlbum() {
	const swiperSlides = document.getElementsByClassName('swiper-slide');
	const firstAlbum = swiperSlides[0];
	const firstAlbumImgSrc = firstAlbum.childNodes[0].src;
	const songsList = JSON.parse(firstAlbum.dataset.songsList);
	const numberOfSongs = songsList.length;
	albumPreviewImg.src = firstAlbumImgSrc;
	albumPreviewWrapper.dataset.numberOfSongs = numberOfSongs;
	albumPreviewWrapper.dataset.activeSong = 1;
	albumPreviewWrapper.dataset.listSongs = JSON.stringify(songsList);
	albumPreviewWrapper.dataset.albumId = JSON.parse(firstAlbum.dataset.albumId);
	albumPreviewWrapper.dataset.albumTitle = firstAlbum.dataset.albumTitle;

	// переписать на функцию с 3 спанами.
	const albumTitle = JSON.parse(firstAlbum.dataset.albumTitle);
	
	// Разбиваем название на две строки для первого альбома
	let titleWithSpan;
	if (albumTitle.includes('Far&High')) {
		titleWithSpan = `<span>Far&High</span><span>& pizzaaftersex</span>`;
	} else {
		titleWithSpan = `<span> ${albumTitle} </span>`;
	}

	albumPreviewTitle.innerHTML = titleWithSpan;
	albumPreviewTitleMobile.innerHTML = titleWithSpan;
}

function setAndRenderPlayerSongTitle() {
	const songTitleNode = document.getElementById('music');
	songTitleNode.innerText = JSON.parse(
		albumPreviewWrapper.dataset.listSongs,
	)[0].title;
}

function setPathSong() {
	const audioFile = document.getElementById('audio-file');
	audioFile.src = `../assets/audio/album-${JSON.parse(
		albumPreviewWrapper.dataset.albumId,
	)}/${JSON.parse(albumPreviewWrapper.dataset.listSongs)[0].path}`;
}

function render() {
	setAndRenderAlbumsSlides();
	setAndRenderPreviewAlbum();
	setAndRenderPlayerSongTitle();
	setPathSong();
}

export default render;
